import React from "react";
import { colors, radii, spacing } from "./theme";

export default function Button({
  children,
  type = "button",
  variant = "primary",
  size = "md",
  disabled = false,
  onClick,
  style = {},
  ...props
}) {
  const variants = {
    primary: {
      background: colors.primary,
      color: "#ffffff",
      border: `1px solid ${colors.primary}`
    },
    secondary: {
      background: colors.surface,
      color: colors.primary,
      border: `1px solid ${colors.borderStrong}`
    },
    ghost: {
      background: "transparent",
      color: colors.textMuted,
      border: "1px solid transparent"
    },
    danger: {
      background: colors.danger,
      color: "#ffffff",
      border: `1px solid ${colors.danger}`
    }
  };

  const sizes = {
    sm: {
      padding: `${spacing.sm}px ${spacing.md}px`,
      fontSize: 13
    },
    md: {
      padding: `${spacing.md}px ${spacing.lg}px`,
      fontSize: 14
    },
    lg: {
      padding: `${spacing.lg}px ${spacing.xl}px`,
      fontSize: 15
    }
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        borderRadius: radii.md,
        fontWeight: 700,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        transition: "all .2s ease",
        ...variants[variant],
        ...sizes[size],
        ...style
      }}
      {...props}
    >
      {children}
    </button>
  );
}